import axios from 'axios'
import { REACT_APP_PERITADOR_API } from '../../config'

export async function putRecepcionManual(body) {
  const recepcionManual = await axios.patch(
    `${REACT_APP_PERITADOR_API}/requests/recepcion_manual`,
    body
  )

  return recepcionManual
}
